// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses environment.ts, but if you do
// ng build --env=prod then environment.prod.ts will be used instead.
// The list of which env maps to which file can be found in .angular-cli.json.

export const environment = {
    production: false,
    apiUrl: 'api/api',
    hostname:getApiUrl(),
    centralApi:'https://pramat-dev.kyticsglobal.com/api/api',
    centralDomainUrl:'https://pramat-dev.kyticsglobal.com/',
    centralDomain:'pramat-dev.kyticsglobal.com',
    maintenanceMode: false,
    maintenanceMessage: 'We are currently performing scheduled maintenance. Please check back shortly.',
  };
  
  function getApiUrl(): string {
    const hostname = window.location.hostname;
    return hostname;
  }